import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-5/12">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-md">
              {t("about.tag")}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-4 leading-tight">
              {t("about.title.line1")}
              <br />
              {t("about.title.line2")}
              <br />
              {t("about.title.line3")}
            </h2>
            <p className="mt-6 text-foreground-600 text-sm md:text-base leading-relaxed max-w-md">
              {t("about.desc1")}
            </p>
            <p className="mt-4 text-foreground-500 text-sm leading-relaxed max-w-md">
              {t("about.desc2")}
            </p>
          </div>

          <div className="lg:w-7/12 w-full">
            <div className="bg-accent-900 rounded-3xl p-8 md:p-10 relative overflow-hidden">
              <div className="flex items-start justify-between mb-8">
                <span className="text-accent-300/60 text-xs font-medium uppercase tracking-wider">
                  {t("about.advantage")}
                </span>
                <div className="flex gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                </div>
              </div>

              <blockquote className="text-white/90 text-base md:text-lg leading-relaxed italic font-heading">
                &ldquo;{t("about.quote")}&rdquo;
              </blockquote>

              <div className="flex items-center justify-between mt-10">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20European%20woman%20portrait%20headshot%20on%20clean%20white%20background%2C%20modern%20corporate%20photography%2C%20soft%20diffused%20lighting%2C%20friendly%20approachable%20expression%2C%20contemporary%20business%20style&width=100&height=100&seq=about-v2-avatar&orientation=squarish"
                      alt={t("about.name")}
                      title="Hipobuy Spreadsheet utilisateur"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-white text-sm font-semibold">{t("about.name")}</p>
                    <p className="text-accent-300/70 text-xs">{t("about.role")}</p>
                  </div>
                </div>
                <button className="w-10 h-10 flex items-center justify-center rounded-xl border border-white/20 text-white/70 hover:bg-white/10 transition-colors" aria-label="Suivant">
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}